// extracted by mini-css-extract-plugin
module.exports = {"cardStyle":"jddetails_cardStyle__3v_3l","listFlex":"jddetails_listFlex__2-dIY","valueStyle":"jddetails_valueStyle__2XAbl"};